module.exports = __webpack_public_path__ + "h5/img/icon_2.d04c503d.png";